import React from 'react';

import type { RootState } from '@/store';
import { selectIsClaimAvailable, selectRewardCampaign } from '@/store/features';
import { connect } from 'react-redux';
import { DailyCampaignDto } from '@/store/services/MidleNestApi.service';
import DailyRewardComponent from '@/components/shared/daily-reward/DailyReward.component';

interface RewardsViewProps {
  campaign?: Partial<DailyCampaignDto>;
  isAvailable?: boolean;
}

function DailyRewardView({ campaign = {}, isAvailable = false }: RewardsViewProps) {
  return (
    <div className='max-w-screen'>
      <DailyRewardComponent campaign={campaign} isAvailableToday={isAvailable} />
    </div>
  );
}

export default connect((state: RootState) => ({
  campaign: selectRewardCampaign(state),
  isAvailable: selectIsClaimAvailable(state),
}))(DailyRewardView);
